import { Link } from "react-router-dom";
import { Gem, Phone, MessageCircle, Mail, Clock } from "lucide-react";
import {
  SUPPORT_PHONE_E164, SUPPORT_PHONE_DISPLAY, SUPPORT_WHATSAPP_URL,
  SUPPORT_EMAIL, SUPPORT_HOURS,
} from "@/lib/support";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-card mt-24">
      <div className="max-w-[1400px] mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-6 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <Gem className="h-6 w-6 text-primary" strokeWidth={1.5} />
            <span className="font-display font-extrabold text-lg">Jewel<span className="text-primary">tix</span></span>
          </div>
          <p className="text-sm text-muted-foreground max-w-xs">
            The world's marketplace exclusively for jewellery CAD design files — 3DM &amp; STL,
            built for manufacturers, CAD studios, and 3D printing units across the globe.
          </p>
        </div>
        <FooterCol title="Marketplace" links={[["Browse Files", "/marketplace"], ["Designers", "/designers"], ["Pricing", "/pricing"]]} />
        <FooterCol title="Platform" links={[["How it Works", "/how-it-works"], ["About", "/about"], ["FAQs", "/faq"]]} />
        <FooterCol title="Legal" links={[["Buyer Terms", "/terms/buyer"], ["Seller Terms", "/terms/seller"], ["CAM Vendor Terms", "/terms/cam-vendor"], ["Privacy Policy", "/privacy"], ["Grievance Officer", "/grievance"], ["Refund Policy", "/refund-policy"]]} />
        {/* Support — visible on every page */}
        <div data-testid="footer-support">
          <h4 className="font-display font-semibold text-sm mb-3">Support</h4>
          <ul className="space-y-2.5 text-sm">
            <li>
              <a href={`tel:${SUPPORT_PHONE_E164}`} data-testid="footer-support-call" className="text-muted-foreground hover:text-primary inline-flex items-center gap-2">
                <Phone className="h-3.5 w-3.5" /> {SUPPORT_PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a href={SUPPORT_WHATSAPP_URL} target="_blank" rel="noreferrer" data-testid="footer-support-whatsapp" className="text-muted-foreground hover:text-emerald-500 inline-flex items-center gap-2">
                <MessageCircle className="h-3.5 w-3.5" /> WhatsApp us
              </a>
            </li>
            <li>
              <a href={`mailto:${SUPPORT_EMAIL}`} className="text-muted-foreground hover:text-primary inline-flex items-center gap-2">
                <Mail className="h-3.5 w-3.5" /> {SUPPORT_EMAIL}
              </a>
            </li>
            <li className="text-xs text-muted-foreground inline-flex items-center gap-2">
              <Clock className="h-3 w-3" /> {SUPPORT_HOURS}
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-[1400px] mx-auto px-6 py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-muted-foreground font-mono">
          <span>© 2026 Jeweltix Technologies. All rights reserved.</span>
          <span>Escrow-Protected · 2-Day Payout Hold · Verified Designers</span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="font-display font-semibold text-sm mb-3">{title}</h4>
      <ul className="space-y-2">
        {links.map(([label, to]) => (
          <li key={to}>
            <Link to={to} className="text-sm text-muted-foreground hover:text-primary transition-colors">{label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
